import { useEffect, useMemo, useState } from 'react';

import { Collection } from '../snippets';
import { useDataLayerActions } from '../hooks';
import drillObject from '../utils/drillObject';

export default function CollectionTemplate({ collection, renderSections }) {
  const sections = renderSections();
  const { sendViewCollectionEvent } = useDataLayerActions();

  // adding collection via section allows control of order of grid on the page
  // otherwise, collection is hardcoded after all sections
  const { sectionsBeforeCollection, sectionsAfterCollection } = useMemo(() => {
    if (!sections?.length) return {};

    const visibleCollectionSectionIndex = sections.findIndex(({ props }) => {
      return props?.['data-comp'] === 'collection' && !props?.hidden;
    });

    const collectionPostitionIndex =
      visibleCollectionSectionIndex >= 0
        ? visibleCollectionSectionIndex
        : sections.length;

    return {
      sectionsBeforeCollection: sections.slice(0, collectionPostitionIndex),
      sectionsAfterCollection: sections.slice(collectionPostitionIndex + 1),
    };
  }, [sections]);

  const [collectionProducts, setCollectionProducts] = useState(
    collection?.products || []
  );
  useEffect(() => {
    // get cms settings for collection section
    if (!sections?.length) return;

    // get collection section
    const collectionSection = sections.find(({ props }) => {
      return props?.['data-comp'] === 'collection' && !props?.hidden;
    });

    // find cms settings from collection section
    const cms = drillObject(collectionSection, ['props', 'children', 'cms']);

    // if separateProductsByType is disabled, unset productType from products
    // otherwise, keep collection products as is
    let collectionProductsArr;
    if (cms?.seprateByType === false) {
      collectionProductsArr = [...collection.products].map((item) => {
        return {
          ...item,
          productType: '',
        };
      });
    } else {
      collectionProductsArr = collection.products;
    }
    setCollectionProducts(collectionProductsArr);
  }, [sections, collection.products]);

  useEffect(() => {
    if (!collection) return;
    sendViewCollectionEvent({
      products: collection.products,
      collectionId: collection.id,
    });
  }, [
    `${collection?.id}${!!collection?.products?.length}`,
    sendViewCollectionEvent,
  ]);

  return (
    <div>
      {sectionsBeforeCollection || null}

      <div className="md-px-contained py-contained bg-[var(----clearBlue)] max-md:!pt-0">
        <Collection
          handle={collection?.handle}
          products={collectionProducts}
          showHeading
          title={collection?.title}
        />
      </div>

      {sectionsAfterCollection || null}
    </div>
  );
}

CollectionTemplate.displayName = 'CollectionTemplate';
